import styled from 'styled-components';
import { Modal } from 'antd';

export default styled(Modal)`
  
`